export default "__VITE_ASSET__DytUdDkW__"